import { applySnapshot } from 'mobx-state-tree';
import { model, RootModel as BaseRootModel } from 'mst-collection';

import { AuthModel } from './AuthModel';
import { EntitiesModel } from './EntitiesModel';
import { QuestionnaireModel } from './Questionnaire/QuestionnaireModel';
import { TracksModel } from './Tracks/TracksModel';
import { TutorialsModel } from './Tutorials/TutorialsModel';
import { ViewerModel } from './Viewer/ViewerModel';
import { AppModel } from './App/AppModel';
import { NotificationsModel } from './Notifications/NotificationsModel';
import { ChatsModel } from './Chats/ChatsModel';
import { PostsModel } from './Posts/PostsModel';
import { SupportModel } from './Support/SupportModel';
import { SearchModel } from './Search/SearchModel';
import { TagsModel } from './Tags/TagsModel';
import { SkillLevelQuestionnaireModel } from './Questionnaire/SkillLevelQuestionnaireModel';
import { SectionsModel } from './Sections/SectionsModel';
import { ItemsModel } from './Items/ItemsModel';

export class Root extends BaseRootModel({
  auth: AuthModel,
  viewer: ViewerModel,
  questionnaire: QuestionnaireModel,
  skillLevelQuestionnaire: SkillLevelQuestionnaireModel,
  tutorial: TutorialsModel,
  track: TracksModel,
  app: AppModel,
  notifications: NotificationsModel,
  chats: ChatsModel,
  posts: PostsModel,
  support: SupportModel,
  search: SearchModel,
  tags: TagsModel,
  sections: SectionsModel,

  items: ItemsModel,

  entities: EntitiesModel,
}) {
  reset() {
    applySnapshot(this, {});
  }
}

export const RootModel = model(Root);

export type RootModelType = typeof RootModel;
